import React, { Component, Fragment } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import Spinner from "../../../components/UI/Spinner/Spinner";
import * as drexiLogin from "../../../store/actions/index";
import { Container, Image } from "react-bootstrap";

import classes from "./Feature.module.css";

interface IStateFromProps {
  drexiOtp: string;
  loading: boolean;
}
interface IDispatchFromProps {
  onFetchDrexiSessionId: (userId: string) => void;
}

interface IProps {
  group: string;
  name: string;
  path: string;
}
type Props = IStateFromProps & IDispatchFromProps & IProps;
class Feature extends Component<Props & RouteComponentProps> {
  clickHandler = () => {
    console.log("this.props.path", this.props.path);
    if (this.props.path === "pharmacy") {
      this.props.onFetchDrexiSessionId(localStorage.getItem("userId")!);
    } else if (this.props.path !== "prescriptions") {
      this.props.history.push("/" + this.props.path);
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.drexiOtp !== this.props.drexiOtp &&
      this.props.drexiOtp &&
      this.props.path.toLowerCase() === "pharmacy"
    ) {
      // window.open("https://angular.com");
      console.log("this.props.drexiOtp", this.props.drexiOtp);
      window.open(
        `${process.env.REACT_APP_DREXI_URL}/sso/totplogin?totp=${this.props.drexiOtp}`
      );
    }
  }
  render() {
    return (
      <div className="fContainer" onClick={this.clickHandler}>
        <Image
          src={require("../../../assets/images/" + this.props.group)}
          alt="group"
          className={classes.Group}
        />
        <p className={classes.featureText}>{this.props.name}</p>
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  drexiOtp: state.drexiLogin.drexiOtp,
  loading: state.drexiLogin.loading,
  error: state.drexiLogin.error,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchDrexiSessionId: (userId: string) =>
    dispatch(drexiLogin.getDrexiSessionId(userId)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Feature));
